import axios from "axios";


const baseURL="https://online-course-admin.onrender.com/api"
const getAllVideoList= axios.get(baseURL+"/video-lists?populate=*");
export default{
    getAllVideoList
}